<svg xmlns="http://www.w3.org/2000/svg" width="12" height="3" viewBox="0 0 12 3">
  <path fill="#4562FF" fill-rule="evenodd"
        d="M10.974 0C11.541 0 12 .504 12 1.125s-.46 1.125-1.026 1.125H1.026C.459 2.25 0 1.746 0 1.125S.46 0 1.026 0h9.948z"/>
</svg>
